import React,{ useState } from 'react';
import { useDispatch } from 'react-redux';
import ButtonGroupWrapper from './ButtonGroup.styles';
import { Row, Col, Button } from 'antd';
import {
  FileProtectOutlined,
  SafetyOutlined,
  WarningOutlined,
  PlusCircleOutlined,
  EnvironmentOutlined,
  FormOutlined,
  GlobalOutlined,
  ReadOutlined,
} from '@ant-design/icons';
import IntlMessages from '@iso/components/utility/intlMessages';
import { useHistory ,useLocation } from 'react-router-dom';
import appActions from '@iso/redux/app/actions';
import FormModal from '../Form/FormModal';
import SelectTrainingAssetModal from './SelectTrainingAssetModal';

const { changeCurrent} = appActions;

const ButtonGroup = (props) => {
  const { propertyId, showModalHealthSafety, onShowActivityModal, onOpenSafetyDocuments } = props;
  const [ visibleFormModal, setVisiblityFormModal ] = useState(false);
  const [ visibleTrainingModal, setVisibleTrainingModal ] = useState(false);
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();

  const handleRedirectPage = (e,path) => {
    history.push(e);
    dispatch(changeCurrent([path]));
  }

  const showModalActivity = (value) =>{
    if (typeof onShowActivityModal === 'function') {
      onShowActivityModal(value);
    }
  }
  const handleOpenModal = () => {
    setVisiblityFormModal(true);
  };
  const cancelModal = () => {
    setVisiblityFormModal(false);
  };

  const handleOpenTrainingModal = () => {
    setVisibleTrainingModal(true);
  };

  const handleCancelTrainingModal = () => {
    setVisibleTrainingModal(false);
  };

  const handleSelectTrainingAsset = (educationAsset) => {
    if (typeof onShowActivityModal === 'function') {
      onShowActivityModal('training_session', null, { educationAsset });
    }
  };

  // Quick actions — white cards with an icon reflecting the action (Figma).
  const actions = [
    { icon: <FileProtectOutlined />, label: 'Safety Documents', onClick: () => typeof onOpenSafetyDocuments === 'function' && onOpenSafetyDocuments() },
    { icon: <SafetyOutlined />, label: <IntlMessages id="safeFarmPage.dashboard.safetyWalk" />, onClick: () => showModalActivity('safety_walk') },
    { icon: <WarningOutlined />, label: <IntlMessages id="safeFarmPage.dashboard.hazardRisk" />, onClick: () => showModalActivity('hazard') },
    { icon: <PlusCircleOutlined />, label: <IntlMessages id="dashboard.historyChart.title" />, onClick: () => showModalActivity() },
    { icon: <EnvironmentOutlined />, label: <IntlMessages id="healthSafety.addHealthSafety" />, onClick: () => showModalHealthSafety() },
    { icon: <FormOutlined />, label: <IntlMessages id="safeFarmPage.dashboard.forms" />, onClick: handleOpenModal },
    { icon: <GlobalOutlined />, label: <IntlMessages id="sidebar.propertyMap" />, onClick: () => handleRedirectPage('map','map') },
    { icon: <ReadOutlined />, label: <IntlMessages id="healthSafety.recordTraining" />, onClick: handleOpenTrainingModal },
  ];

  return (
    <ButtonGroupWrapper>
      <div className="statistic-card">
        <Row gutter={[12,12]}>
          {actions.map((action, i) => (
            <Col key={i} xs={{span: 12}} sm={{span: 8}} md={{span: 6}} lg={{span: 3}}>
              <Button block className="ant-btn--sf-dashboard" onClick={action.onClick}>
                <span className="sf-btn-icon">{action.icon}</span>
                <span className="sf-btn-label">{action.label}</span>
              </Button>
            </Col>
          ))}
        </Row>
      </div>
      <FormModal
        cancelModal={cancelModal}
        visibleFormModal={visibleFormModal}
        propertyId={propertyId}
        fromProperty={true}
      />
      <SelectTrainingAssetModal
        visible={visibleTrainingModal}
        onCancel={handleCancelTrainingModal}
        onSelect={handleSelectTrainingAsset}
        propertyId={propertyId}
      />
    </ButtonGroupWrapper>

  );
}

export default ButtonGroup;
